(function (angular) {
	'use strict';

	angular
		.module('manageBankAccountsModule')
		.controller('ManageBankAccounts', [
			'$rootScope',
			'$timeout',
			'$window',
			'globalConfig',
			'mixpanelFactory',
			'PlaidFactory',
			'urlFactory',
			ManageBankAccountsFunction
		]);


	function ManageBankAccountsFunction(
		$rootScope,
		$timeout,
		$window,
		globalConfig,
		mixpanelFactory,
		PlaidFactory,
		urlFactory) {
		
		var manageBankAccounts = this;
		
		manageBankAccounts.openPlaid = function(){
			manageBankAccounts.plaidObject.open();
			mixpanelFactory.track('Plaid Link Account Button Clicked');
		};

		manageBankAccounts.submitMakePrimary = function(account) {
			account.isDisabled = true;
			urlFactory.redirect(account.id + '/set-as-primary', true);
		};		

		function errorLinkingPlaidAccount() {
			$timeout(function(){
				$rootScope.ModalFactory.openDisclaimer('invalid-plaid-account-selected', 
					{
						inputs: {
							title: 'Link Bank Account Manually'
						}
					}
				);
			});
		}

		function onExitPlaidLink(onExitStatus) {
			$timeout(function(){
				if(onExitStatus === "institution_not_found") {
					manageBankAccounts.activeModal = 'modal-institution-not-found-plaid';
				}
			});
		}

		function successfullyLinkedPlaidAccount() {
			urlFactory.reload();
		}

		manageBankAccounts.$onInit = function() {
			manageBankAccounts.accounts = globalConfig.accounts;

			manageBankAccounts.plaidObject = PlaidFactory.getPlaid(
				successfullyLinkedPlaidAccount,
				errorLinkingPlaidAccount,
				onExitPlaidLink);
		};

	}
})(window.angular);